var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"header"},[_vm._m(0),_c('div',{staticClass:"header__right"},[_c('div',{staticClass:"header__logout",on:{"click":_vm.logout}},[_c('img',{attrs:{"src":require("../../assets/logout.svg"),"alt":"cart"}})])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',[_c('img',{attrs:{"src":require("../../assets/logo.svg"),"alt":"logo"}})])
}]

export { render, staticRenderFns }